module.exports = __webpack_public_path__ + "static/media/bandcamp.da272e9c.svg";